import { useRouter } from 'next/router';

export const useVideoNavigation = () => {
  const router = useRouter();

  const push = async (videoUrl: string) => {
    await router.push({
      query: { ...router.query, video: encodeURI(videoUrl!) },
    });
  };
  return { push };
};
